const icon = `
<svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 35" style="enable-background:new 0 0 35 35;" xml:space="preserve">
<style type="text/css">
	.st0{fill:{{strokeColor}};}
</style>
  <path class="st0" d="M10.2,17.3h-4.2v3.7h4.7v1.9H3.9v-12.5h6.6v1.9h-4.5v3.2h4.2v1.9Z"/>
  <path class="st0" d="M21.5,24.7c-1.5-.5-2.9-1-4.2-1.6-.2,0-.5-.2-.7-.2-2.5-.1-4.8-2.2-4.8-6.2s2.1-6.4,5.2-6.4,5,2.7,5,6.2-1.2,5-2.8,5.7h0c.9.4,2,.6,2.9.8l-.6,1.8ZM19.9,16.6c0-2.3-1-4.5-3-4.5s-3,2.1-3,4.6c0,2.5,1.1,4.5,3,4.5s3-2,3-4.6Z"/>
  <path class="st0" d="M23.6,10.5c.7-.1,1.7-.3,3.1-.3s2.6.4,3.3,1c.7.6,1.1,1.6,1.1,2.7s-.3,2.2-1,2.8c-.8.9-2.1,1.3-3.5,1.3s-.7,0-1,0v4.7h-2v-12.3ZM25.6,16.3c.2,0,.6,0,1,0,1.5,0,2.5-.8,2.5-2.3s-.9-2.1-2.3-2.1-1,0-1.2.1v4.2Z"/>
</svg>
`

export const EQP = {
  name: 'EQP',
  description: 'The object groups composing the EQP system',
  icon,
  templates: []
}
